import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  bg: {
    background: "#fff",
    borderRadius: "10px",
    padding: "20px",
    marginTop: "20px",
  },
}));
